import { PinturaDefaultImageWriterResult, createDefaultImageOrienter, createDefaultImageReader, createDefaultImageWriter, getEditorDefaults, locale_en_gb, plugin_crop, plugin_crop_locale_en_gb, plugin_finetune, plugin_finetune_defaults, plugin_finetune_locale_en_gb, setPlugins } from "@pqina/pintura";
import { PinturaEditor } from "@pqina/react-pintura";
import axios, { AxiosProgressEvent } from "axios";
import { ChangeEvent, createRef, forwardRef, useImperativeHandle, useState } from "react";
import useAuth from "../lib/useAuth";
import { okModal } from "../lib/utils";
import { Modal, Progress, Space, Text } from "@mantine/core";
import Editable from "./Editable";
import { useAuth as useClerkAuth } from "@clerk/nextjs";

import styles from './ImageUpload.module.scss'
import '@pqina/pintura/pintura.css';

import {getClerkHeader} from '../lib/common';

setPlugins(plugin_crop, plugin_finetune);

const editorDefaults = {
  imageReader: createDefaultImageReader(),
  imageWriter: createDefaultImageWriter(),
  imageOrienter: createDefaultImageOrienter(),
   ...plugin_finetune_defaults,
  locale: {
      ...locale_en_gb,
      ...plugin_crop_locale_en_gb,
      ...plugin_finetune_locale_en_gb
  },
};


export type ImageUploadHandle = {
    show: ()=> void
  };

  
export type ImageUploadedProps =
{
    title:string,
    data: any
}

type ImageUploadProps = {
    showTitle: boolean,
    postRoute: string,
    onUploaded: (props: ImageUploadedProps) => void,
    square?: boolean,
    circleOverlay?: boolean
}


export const ImageUpload = forwardRef<ImageUploadHandle,ImageUploadProps>((props, ref) => 
{



    useImperativeHandle(ref, () => ({
        
        show() {
            uploadImage();
        }
      }));

      let editorRef = createRef<PinturaEditor>();
      let [uploadFile, setUploadFile] = useState<File|string>('');
      
      const [showUpload, setShowUpload] = useState(false);
      const [uploadProgress, setUploadProgress] = useState(0);
      const [showUploadProgress, setShowUploadProgress] = useState(false);
      const {authToken} = useAuth();
      const { getToken } = useClerkAuth();

      
      let [uploadTitle, setUploadTitle] = useState('');
  
      let fileRef = createRef<HTMLInputElement>();
  
      let aspectRatio = props.square?1:undefined;

      async function uploadImage()
      {
    
        setUploadFile('');
        setUploadTitle('');

        if (fileRef.current)
        {
          fileRef.current.value='';
          fileRef.current.click();
        }
      }
  
      
      function closeUpload()
      {
        setShowUpload(false);
        setUploadFile('');
      }
  
      async function updateUploadProgress (e: AxiosProgressEvent)
      {
          setUploadProgress((e.progress??0)*100);
      }
  
      async function handleEditorProcess(e : PinturaDefaultImageWriterResult)
  {
    setShowUpload(false);
    setUploadProgress(0);
    setShowUploadProgress(true);
  
    try
    {
      let formData = new FormData();
      formData.append("description", uploadTitle);
      formData.append("file", e.dest);
  
      const clerkToken = await getToken();
      
      let a= await axios.post(props.postRoute,
        formData,
        {
            headers:{'Content-Type': 'multipart/form-data', 'auth-token': authToken, ...getClerkHeader(clerkToken)},
            onUploadProgress: updateUploadProgress                    
        });
        setShowUploadProgress(false);

        props.onUploaded({title: uploadTitle, data: a.data});
  
    }
    catch(e)
    {
        okModal("There was a problem uploading the image");
    }
    finally
    {
        setShowUploadProgress(false);
    }


  
  }
  
  function clickedDone(e: React.MouseEvent<HTMLAnchorElement>)
  {
    editorRef?.current?.editor.processImage();
    e.preventDefault();
  }
  
  
  function handleFileChange(e : ChangeEvent<HTMLInputElement>)
  {
    if (e.target.files?.length==1)
    {
      let file = e.target.files[0];
      if (editorRef)
      {  
       // console.log(file.name);
       // editorRef.current?.editor.loadImage(file);
       setUploadFile(file);
      }
      setShowUpload(true);
  
      //this works!
      //openDefaultEditor({src:file});
    }
  }
  
  function saveUploadTitleText(x: string)
  {
    setUploadTitle(x);
  }

  function renderCanvas(shapes: any, state: any)
  {
    const {
      utilVisibility,
      selectionRect,
      lineColor,
      backgroundColor,
  } = state;

  // Exit if crop utils is not visible
  if (utilVisibility.crop <= 0) return shapes;

  if (!props.circleOverlay)
  {
    return shapes;
  }

  // Get variable shortcuts to the crop selection rect
  const { x, y, width, height } = selectionRect;

  return {
      // Copy all props from current shapes
      ...shapes,

      // Now we add an inverted ellipse shape to the interface shapes array
      interfaceShapes: [
          {
              x: x + width * 0.5,
              y: y + height * 0.5,
              rx: width * 0.5,
              ry: height * 0.5,
              opacity: utilVisibility.crop,
              inverted: true,
              backgroundColor: [...backgroundColor, 0.5],
              strokeWidth: 1,
              strokeColor: [...lineColor],
          },
          // Spread all existing interface shapes onto the array
          ...shapes.interfaceShapes,
      ],
  };

  }
  
  return (
      <>
      <input ref={fileRef} style={{display:"none"}} type="file"  accept="image/*" onChange={handleFileChange}/>
          
      <Modal opened={showUpload} onClose={()=>{closeUpload(); }} size="auto" >
                  <div style={{width:"80vw", height:"calc(75vh)"}}>
                    <h2 style={{textAlign:"center"}}>Edit your image, and then click &lsquo;<a href='#' onClick={clickedDone}>done</a>&rsquo;</h2>
                      <div style={{width:"100%", minWidth:200}}>
                        
                        {props.showTitle && <Editable centre placeholder="My title" prompt="Optionally, click here to give your image a title" value={uploadTitle} onSave={saveUploadTitleText}/>
  }
                        </div>
                        <div style={{width:"100%", height: "calc(100% - 100px)"}}>
                        <PinturaEditor imageCropAspectRatio={aspectRatio} willRenderCanvas={renderCanvas} onProcess = {async(x)=>await handleEditorProcess(x)} src={uploadFile} ref={editorRef} {...editorDefaults} ></PinturaEditor>

           </div>
          </div>
          </Modal>
  
          <Modal opened={showUploadProgress} onClose={()=>{}} withCloseButton={false} size="sm">
          <Text ta="center">Uploading ...</Text>
          <Space h='md'></Space>
          <Progress className={styles.progressBar} value={uploadProgress}/>
  
          </Modal>
      </>);
  
    });

    ImageUpload.displayName="ImageUpload";



